// Leitura de uma tela de PDV (itemInfo tipo 2) antes de ela entrar no editor.
//
// Por que isto não usa o `parseInfoValue` da Configuração: aquele devolve `{}`
// quando o JSON não parseia, e `{}` é indistinguível de uma tela legitimamente
// vazia. Quem salvasse em cima disso gravaria "{}" por cima do valor bom, em
// silêncio — e o único rastro seria um console.error que ninguém lê.
//
// O que sai daqui carrega, junto com o objeto, as três coisas que o salvamento
// precisa saber e que o objeto sozinho não conta:
//   parseOk        o JSON prestou?
//   valorOriginal  o valor normalizado que veio do banco (para saber se mudou)
//   formatoAntigo  está no schema velho do Central (`components`/`styles`)?
import { TelaDePdv } from "./tipos";

/**
 * O editor lê `parsedValue.saleOptionComponents`. O Central antigo guarda a
 * mesma coisa em `components`, com `styles` ao lado — é outro schema, não uma
 * variação. Uma tela dessas abre VAZIA no editor, e salvar dali gravaria o
 * vazio por cima do cardápio.
 *
 * Traduzir de um formato para o outro NÃO é trabalho de tela: é migração de
 * dado, e quem faz isso é o alinhamento OPS -> Central. Aqui a tela só
 * reconhece e recusa — a mesma recusa que o worker do OPS faria depois,
 * antecipada para antes de sujar o banco.
 */
export function ehFormatoAntigoDoCentral(valor: any): boolean {
  if (!valor || typeof valor !== "object") return false;
  return (
    !("saleOptionComponents" in valor) &&
    ("components" in valor || "styles" in valor)
  );
}

/** Lê o `itemInfoValue` gravado e devolve o que o editor e o salvamento usam. */
export function lerTelaDePdv(info: any): TelaDePdv {
  const bruto = info?.itemInfoValue;

  let valor: any = null;
  let parseOk = false;
  try {
    valor = JSON.parse(bruto);
    parseOk = valor !== null && typeof valor === "object" && !Array.isArray(valor);
  } catch {
    parseOk = false;
  }

  if (!parseOk) {
    return {
      ...info,
      parsedValue: {},
      parseOk: false,
      valorOriginal: "",
      formatoAntigo: false,
    };
  }

  return {
    ...info,
    parsedValue: valor,
    parseOk: true,
    // Normalizado pelo mesmo caminho que o salvamento usa (JSON.parse ->
    // JSON.stringify). Sem isso, a mera diferença de espaçamento do texto
    // gravado faria toda abertura de item parecer uma edição.
    valorOriginal: JSON.stringify(valor),
    formatoAntigo: ehFormatoAntigoDoCentral(valor),
  };
}
